/** @jsxImportSource theme-ui @jsxRuntime classic */
import * as Icons from '@tishman/icons';
import React from 'react';

import { Text, Box, useThemeUI } from '..';

export const FooterWifi = (): React.JSX.Element => {
  const themeUI = useThemeUI();
  return (
    <Box
      sx={{
        width: ['100%', 'unset'],
        mt: 4,
        mb: 4,
      }}
    >
      <Text as="h2" sx={{ mb: 1 }} variant="footerFirstSectionHeading">
        Stay Connected
      </Text>
      <Text sx={{ fontWeight: [300, null, null, 400] }}>
        <Box
          sx={{
            width: '100%',
            maxWidth: ['232px', 'initial'],
            display: ['block', null, null],
            mr: [2, 0, null, null],
          }}
        >
          Stay connected with free Wi-Fi at Rockefeller Center.
        </Box>
        <Box
          sx={{
            width: '100%',
            display: ['block', null, null],
            whiteSpace: 'nowrap',
          }}
        >
          @Rock Center Free Wi-Fi{' '}
          <Icons.Wifi
            aria-hidden
            style={{
              marginLeft: themeUI.theme.space[1],
              marginRight: themeUI.theme.space[1],
              height: 14,
            }}
          />
        </Box>
      </Text>
    </Box>
  );
};
